import { Component, Input } from '@angular/core';

@Component({
    selector: 'xlog-omni-loader',
    templateUrl: './omni-loader.component.pug',
    styleUrls: ['./omni-loader.component.scss'],
    standalone: false
})
export class OmniLoaderComponent {
    @Input() hide = true;

    constructor() { }

}
